module.exports = __webpack_public_path__ + "static/img/7.991c261.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/7.png
// module id = Ny0W
// module chunks = 0